import { insightsCache } from '@/modules/simulations/insightsCache';

import type { CacheLifecycle } from './scopedCache';

export const registeredCaches: readonly CacheLifecycle[] = [insightsCache];
